import type { ComparisonRow, ComparisonSortMode } from './ComparisonTypes'

/**
 * ComparisonSorter — row-level ordering for the comparison table.
 */
export class ComparisonSorter {
  sort(
    rows: ComparisonRow[],
    mode: ComparisonSortMode,
    preferredProvider: string | null = null,
  ): ComparisonRow[] {
    const copy = [...rows]
    switch (mode) {
      case 'stock_desc':
        return copy.sort((a, b) => b.bestStock - a.bestStock || (a.bestPrice ?? 0) - (b.bestPrice ?? 0))
      case 'delivery_asc':
        return copy.sort(
          (a, b) =>
            (a.bestDelivery ?? 99) - (b.bestDelivery ?? 99) ||
            (a.bestPrice ?? 0) - (b.bestPrice ?? 0),
        )
      case 'margin_desc':
        return copy.sort(
          (a, b) => (b.bestMargin ?? 0) - (a.bestMargin ?? 0) || (a.bestPrice ?? 0) - (b.bestPrice ?? 0),
        )
      case 'preferred':
        return copy.sort((a, b) => {
          const aHit = preferredProvider
            ? a.offers.some((o) => o.supplierId === preferredProvider)
            : false
          const bHit = preferredProvider
            ? b.offers.some((o) => o.supplierId === preferredProvider)
            : false
          if (aHit !== bHit) return aHit ? -1 : 1
          return (a.bestPrice ?? 0) - (b.bestPrice ?? 0)
        })
      case 'availability':
        return copy.sort((a, b) => {
          const aAvail = a.offers.filter((o) => o.stock > 0).length
          const bAvail = b.offers.filter((o) => o.stock > 0).length
          return bAvail - aAvail || (a.bestPrice ?? 0) - (b.bestPrice ?? 0)
        })
      case 'price_asc':
      default:
        return copy.sort((a, b) => (a.bestPrice ?? Number.POSITIVE_INFINITY) - (b.bestPrice ?? Number.POSITIVE_INFINITY))
    }
  }
}

export const comparisonSorter = new ComparisonSorter()
